import { useQuery } from '@tanstack/react-query';
import { categoryService, 
  type GetUpperCategoriesRequest, 
  type GetUpperCategoriesResponse,
  type GetAllCategoriesRequest,
  type GetAllCategoriesResponse
} from '../services/categoryService';

export { categoryService };

// Get upper categories
export function useGetUpperCategories(
  params: GetUpperCategoriesRequest = {},
  enabled = true
) {
  return useQuery({
    queryKey: ['categories', 'upper', params],
    queryFn: async () => {
      const res = await categoryService.getUpperCategories(params);
      return res.responseValue as GetUpperCategoriesResponse;
    },
    enabled,
  });
}

// Get all categories
export function useGetAllCategories(
  params: GetAllCategoriesRequest = {},
  enabled = true
) {
  return useQuery({
    queryKey: ['categories', 'all', params],
    queryFn: async () => {
      const res = await categoryService.getAllCategories(params);
      return res.responseValue as GetAllCategoriesResponse;
    },
    enabled,
  });
}
